// PostVideoPlayer.js
import { connect } from 'react-redux';

import getAssetData from '../selector/getAssetData.js';
import getModalData from '../selector/getModalData.js';
import getMessageData from '../selector/getMessageData.js';
import getMessageThumbnail from '../selector/getMessageThumbnail.js';
import getShouldAutoplayPost from '../selector/getShouldAutoplayPost.js';
import getUserData from '../selector/getUserData.js';
import getMeData from '../selector/getMeData.js';
import getMessageDataWithVariable, {
  VariableName,
} from '../selector/getMessageDataWithVariable.js';
import getTimestampOffset, {
  Accuracy,
} from '../selector/getTimestampOffset.js';
import getRemoteConfigData from '../selector/getRemoteConfigData.js';
import togglePostAssetFullscreenModal from '../action/togglePostAssetFullscreenModal.js';
import setCurrentAutoplayPostId from '../action/setCurrentAutoplayPostId.js';
import { getIsOnAndroid } from '../resource/getUserAgent.js';
import fetchAssetManifest from '../action/fetchAssetManifest.js';

import withRouter from '../component/WithRouter.jsx';
import PostVideoPlayer from '../component/PostVideoPlayer.jsx';
import { POST_COVER_IMAGE_SIZE, PREVIEW_PRESET } from '../RemoteConfigKeys.js';
import getIsNewlyUnlockedMessage from '../selector/getIsNewlyUnlockedMessage.js';
import updateEngagementData from '../action/updateEngagementData.js';
const MODAL_ID = 'PostAssetFullscreenModal';

const mapStateToProps = (state, { postId, assetId, isActive, index }) => {
  const canViewMedia = getMessageData(state, postId, 'canViewMedia');
  const senderId = getMessageData(state, postId, 'senderId');
  const mediaType = getAssetData(state, [assetId], 'contentType');
  const isVideo = mediaType?.startsWith('video');
  const shouldAutoplayPostInFeed = getShouldAutoplayPost(state, postId);
  // Post should autoplay (in viewport), and post active message is intersecting
  const shouldAutoplayPost = isActive && shouldAutoplayPostInFeed;
  const hasVerified = getRemoteConfigData(state, PREVIEW_PRESET) === 'clear';
  const thumbnail = getMessageThumbnail(
    state,
    postId,
    assetId,
    '256x256',
    'jpg',
    hasVerified && (canViewMedia || index === 0) ? 'clear' : 'blurred'
  );
  const isOnAndroid = getIsOnAndroid();
  const meUsername = getMeData(state, 'username');
  return {
    canViewMedia,
    mediaType,
    senderId,
    senderName: getUserData(state, senderId, 'username'),
    isVideo,
    captionText: getMessageDataWithVariable(
      state,
      postId,
      'captionText',
      `${VariableName.USERNAME}:${meUsername}`
    ),
    shouldAutoplayPost,
    isFullscreenModalOpened:
      getModalData(state, MODAL_ID, 'status') === 'display',
    thumbnail,
    isOnAndroid,
    duration: getAssetData(state, [assetId, 'duration']),
    posterSize: getRemoteConfigData(state, POST_COVER_IMAGE_SIZE),
    timestampOffsetMilliseconds: getTimestampOffset(
      state,
      Accuracy.MILLISECOND
    ),
    viewScope: getMessageData(state, postId, 'viewScope'),
    isFree: getMessageData(state, postId, 'unlockPrice') === 0,
    isNewlyUnlocked: getIsNewlyUnlockedMessage(state, postId),
  };
};

const mapDispatchToProps = dispatch => {
  return {
    togglePostAssetFullscreenModal: ({ postId, clickedAssetId }) =>
      dispatch(togglePostAssetFullscreenModal({ postId, clickedAssetId })),
    setCurrentAutoplayPostId: postId =>
      dispatch(setCurrentAutoplayPostId(postId)),
    fetchAssetManifest: ({ assetId, messageId }) =>
      dispatch(fetchAssetManifest({ assetId, messageId })),
    updateEngagementData: data => dispatch(updateEngagementData(data)),
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(PostVideoPlayer)
);
